import { ACTIONS } from "../../common/constants";

const manageTeamReducer = function (state = {}, action) {
  switch (action.type) {
    case ACTIONS.ADD_MEMBERS:
      return { ...state, open: true, ...action.data };
    case ACTIONS.ADD_INSURANCE:
      return { ...state, open: true, ...action.data };
    case ACTIONS.DELETE_USER:
      return { ...state, open: true, ...action.data };
    case ACTIONS.EDIT_USER:
      return { ...state, open: true, ...action.data };
    case ACTIONS.VIEW_USER:
      return { ...state, open: true, ...action.data };
    case ACTIONS.SET_CAPTURE_IMAGE:
      return { ...state, open: true, ...action.data };
    case ACTIONS.CLOSE_POP_UP:
      return { ...state, open: false, data: null };
    case ACTIONS.MANAGE_TEAM_ACTIVE_TAB:
      return { ...state, activeTab: action.data };
    case ACTIONS.VIEW_QUERIES:
      return { ...state, open: true, ...action.data };
    case ACTIONS.RAISE_QUERY:
      return { ...state, open: true, ...action.data };
    case ACTIONS.VIEW_INSURANCE_BENEFITS:
      return { ...state, open: true, ...action.data };
    default:
      return state;
  }
};

export default manageTeamReducer;
